import { useLoadingStore } from "../private/loading-store";

export const useLoading = () => {
  const nuxt = useNuxtApp();
  const store = useLoadingStore();

  return {
    loading: nuxt.$loading,
    asyncLoading: nuxt.$asyncLoading,
    wrapLoading: nuxt.$wrapLoading,
    isLoading: store.loading,
  };
};
